/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ICONS from "../../../../assets/Icons";
import OwnerAccountPopUp from "../../../../components/Accounts/OwnerAccount/OwnerAccountPopUp/index.jsx";
import Loader from "../../../../components/Loader/Index.jsx";
import InternalTransactionGridView from "../../../../components/Transactions/InternalTransaction/InternalTransactionGridView";
import InternalTransactionListView from "../../../../components/Transactions/InternalTransaction/InternalTransactionListView";
import PrimaryButton from "../../../../components/_utils/CommonButtons/PrimaryButton/index.jsx";
import CommonAssignLabelPopup from "../../../../components/_utils/CommonPopups/CommonAssignLabelPopup";
import CommonToast from "../../../../components/_utils/CommonToast";
import TopNavComponent from "../../../../components/_utils/CommonTopNav/TopNavComponent/index.jsx";
import PaginationComponent from "../../../../components/_utils/PaginationComponent/index";
import useRestrictedAction from "../../../../hooks/useRestrictedAction.js";
import { getAllInternalAccounts } from "../../../../redux/features/accounts/internalAccount/index.js";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher.js";
import { ownerAccountsViewAll } from "../../../../redux/features/owner/ownerAllVerification/ownerAllVerification.js";
import {
  internalTransactionsActionable,
  internalTransactionsAddLabel,
  internalTransactionsRemoveLabel,
  internalTransactionsViewAll,
  internalTransactionsViewAllWithBody,
  resetToggle,
  setToggle,
} from "../../../../redux/features/transactions/internalTransactions/index.js";
import {
  GlobalConfiguration,
  IntervalConfiguration,
  PaginationConfiguration,
} from "../../../../utils/configurationProvider.js";
import { standardAccountNumberFormat } from "../../../../utils/standardAccountNumberFormat.js";
import useCustomSearchParams from "../../../../utils/useCustomSearchParams.js";
import useMultiSelect from "../../../../utils/useMultiSelect.js";
import "./index.css";

const InternalTransactionViewAll = (props) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const duplicateFilters = props?.duplicateFilters;
  const {
    handleChange,
    handleSelectAll: handleMultiSelectAll,
    handleSingleSelect,
  } = useMultiSelect();

  const dropdownOptions = PaginationConfiguration.paginationOptions;
  const {
    approvalStatus,
    DistributionDashBoard,
    isConfidentialFilter,
    distribution_lifecycle_status,
    startDateLocationState,
    endDateLocationState,
  } = location.state || {};

  const { searchParam, handleSearchParams } = useCustomSearchParams(
    location?.state && location?.state?.approvalStatus
      ? {
          lifecycle: location?.state?.approvalStatus,
          pageno: GlobalConfiguration.lengthCheckOne,
          pagesize: dropdownOptions[0],
        }
      : {
          pageno: GlobalConfiguration.lengthCheckOne,
          pagesize: dropdownOptions[0],
        },
  );

  const convertDate = (dateString) => {
    if (!dateString) return;
    const date = new Date(dateString);
    const timestamp = Math.floor(
      date.getTime() / IntervalConfiguration.intervalMedium,
    );

    return timestamp;
  };

  const labelActionDispatchedRef = useRef(false);
  const lastElementRef = useRef();
  const scrollContainerRef = useRef(null);
  const navStateAppliedRef = useRef(false);
  const divRef = useRef(null);

  const [divHeight, setDivHeight] = useState(0);
  const [LabelSearchText, setLabelSearchText] = useState([]);
  const [labels, setLabels] = useState([]);
  const [isLabelClicked, setisLabelClicked] = useState(false);
  const [LabelAccounts, setLabelAccounts] = useState([]);
  const [isLabelPopupOpen, setIsLabelPopupOpen] = useState(false);
  // const [accountbalancestate, setaccountbalancestate] = useState(
  //   searchParam.get("sort") || "",
  // );

  const [DashBoardisConfidentialFilter] = useState(isConfidentialFilter);
  const category = location.state ? location.state.category : "";
  const [DashBoardStatus, SetDashBoardStatus] = useState(
    approvalStatus || "all",
  );
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(
    searchParam.get("pageno") || GlobalConfiguration.lengthCheckOne,
  );
  const [accumulatedData, setAccumulatedData] = useState([]);

  const [currentStatus, setCurrentStatus] = useState(
    (props?.typepop === "RejectAllTransactionPopup" ||
      props?.typepop === "RejectInternalAcc") &&
      props?.flow !== "labelsSearch"
      ? "pending"
      : location?.state
        ? location?.state?.approvalStatus
        : searchParam.get("lifecycle") || "",
  );

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [currentCategory] = useState(category ? category : "");
  const [startDateFilter, setStartDateFilter] = useState(
    startDateLocationState
      ? startDateLocationState
      : convertDate(searchParam.get("date")?.split(",")?.[0]) || "",
  );
  const [endDateFilter, setEndDateFilter] = useState(
    endDateLocationState
      ? endDateLocationState
      : convertDate(searchParam.get("date")?.split(",")?.[1]) || "",
  );
  const [isPaymentMethod, setIsPaymentMethod] = useState(
    props?.txnHistorytype === "internalCreateTxn" &&
      duplicateFilters?.payment_method
      ? duplicateFilters?.payment_method
      : searchParam.get("paymentmethod") || "",
  );
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [txnAmount, setTxnAmount] = useState(searchParam.get("amount") || "");
  const [amountRangeFilter, setAmountRangeFilter] = useState(
    props?.txnHistorytype === "internalCreateTxn" && duplicateFilters?.amount
      ? {
          min: duplicateFilters?.amount || "",
          max: duplicateFilters?.amount || "",
        }
      : {
          min: searchParam.get("min_amount") || "",
          max: searchParam.get("max_amount") || "",
        },
  );
  const [, setShowAmtFilterDiv] = useState(false);
  const [isAmtFilterApplied, setIsAmtFilterApplied] = useState(
    !!(searchParam.get("min_amount") || searchParam.get("max_amount")),
  );

  const [txnAddDetails, setTxnAddDetails] = useState(
    searchParam.get("search") || "",
  );
  const [txnAmountFilter, setTxnAmountFilter] = useState(
    searchParam.get("amount") || "",
  );
  const [mainData, setMainData] = useState([]);
  const [selectedBeneAccId, setSelectedBeneAccId] = useState(
    props?.txnHistorytype === "internalCreateTxn" &&
      duplicateFilters?.beneAccountId
      ? duplicateFilters?.beneAccountId
      : props?.txnPayLoad?.beneAccountId
        ? props?.txnPayLoad?.beneAccountId
        : props?.internal_acc_id
          ? props?.internal_acc_id
          : (props?.typepop === "RejectAllTransactionPopup" ||
                props?.typepop === "RejectInternalAcc") &&
              props?.internal_account_id
            ? props?.internal_account_id
            : props?.txnHistorytype === "internalTxnHistory"
              ? props?.internal_account_id
              : props?.OwnerDetail && props?.balanceType === "credit"
                ? props?.BeneAccId
                  ? props?.BeneAccId
                  : ""
                : searchParam.get("beneAcc") || "",
  );
  // const sortMapper = {
  //   "Newest": "newest",
  //   "Oldest first": "oldest",
  //   "Amount:Low to high": "amount_asc",
  //   "Amount:High to low": "amount_desc",
  // };
  const [txnIdSearch, setTxnIdSearch] = useState(
    searchParam.get("txn_id") || "",
  );
  const [selectedOwnerAccId, setSelectedOwnerAccId] = useState(
    props?.txnHistorytype === "internalCreateTxn" && duplicateFilters?.ownerId
      ? duplicateFilters?.ownerId
      : props?.txnPayLoad?.ownerId
        ? props?.txnPayLoad?.ownerId
        : props?.OwnerDetail
          ? props?.OwnerDetail &&
            props?.balanceType === "debit" &&
            props?.owner_account_id
            ? props?.owner_account_id
            : ""
          : props?.owner_account_id
            ? props?.owner_account_id
            : searchParam.get("sourceAcc") || "",
  );

  const [txnIdsFromNotification, setTxnIdsFromNotification] = useState(
    location?.state?.txn_id || [],
  );

  // This will be true when user redirects to this page via notification push banner.
  const [fromNotification, setFromNotification] = useState(
    location?.state?.fromNotification || false,
  );
  const [accountName, setAccountName] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [pageSize, setPageSize] = useState(
    searchParam.get("pagesize") || dropdownOptions[0],
  );
  const [selectedValue, setSelectedValue] = useState(
    searchParam.get("pagesize") || dropdownOptions[0],
  );
  const [totalPages] = useState(GlobalConfiguration.lengthCheckZero);
  const [isCardHovered, setIsCardHovered] = useState(false);
  const [currentStatusDistribution, setCurrentStatusDistribution] = useState(
    searchParam.get("distribution") || distribution_lifecycle_status || "",
  );
  const [isViewModalOpenOwner, setIsViewModalOpenOwner] = useState(false);
  const [isPopoverOpen] = useState(false);
  const [isDistributionPopoverOpen] = useState(false);
  const [totalBalanceAmount, setTotalBalanceAmount] = useState(0);
  const [accountNumber, setAccountNumber] = useState(
    (props?.typepop === "RejectAllTransactionPopup" ||
      props?.typepop === "RejectInternalAcc" ||
      props?.txnHistorytype === "internalCreateTxn") &&
      props?.bank_acc_no
      ? props?.bank_acc_no
      : props?.owner_account_bank_acc_no
        ? props?.owner_account_bank_acc_no
        : "",
  );

  const [IFSC] = useState("");
  const [isConfidentialMethod, setIsConfidentialMethod] = useState(
    (props?.txnHistorytype === "internalCreateTxn" &&
      duplicateFilters?.confidential_transaction ===
        "Show only confidential") ||
      (DashBoardisConfidentialFilter === "Show only confidential" &&
        DashBoardStatus === "confidential") ||
      props?.internal_account_confidential === "Y"
      ? "Show only confidential"
      : props?.internal_account_confidential === "N"
        ? "Hide confidential"
        : searchParam.get("confidential") || "",
  );
  const [bankIdentifierSearch, setBankIdentifierSearch] = useState("");

  const [txnPayLoad, setTxnPayLoad] = useState({
    bankAccountName: "",
    beneAccountId:
      props?.OwnerDetail && props?.balanceType === "credit"
        ? props?.BeneAccId
          ? props?.BeneAccId
          : ""
        : "",
    bankAccountIFSC: "",
    bankAccountNo: props?.owner_account_bank_acc_no
      ? props?.owner_account_bank_acc_no
      : "",
    categories: "",
    pan: "",
    ownerAccountId: props?.OwnerDetail
      ? props?.OwnerDetail &&
        props?.balanceType === "debit" &&
        props?.owner_account_id
        ? props?.owner_account_id
        : ""
      : props?.owner_account_id
        ? props?.owner_account_id
        : "",
    amount: "",
    ownerbankAccountNo: "",
  });
  const [accountNameValue, setAccountNameValue] = useState("");
  const [searchUserTextDebounce, setSearchUserTextDebounce] = useState("");
  const [active, setActive] = useState("");
  const [inputData, setInputData] = useState([]);
  const [showInnerSearchBar, setShowInnerSearchBar] = useState(false);
  const [labelsFilter, setFilterLabels] = useState(
    searchParam.get("label")?.split(",") || props?.labelName?.split(",") || [],
  );
  const [loadingData, setLoadingData] = useState(false);

  const { services } = useSelector((state) => state.refreshToken);
  const { markerData } = useSelector((s) => s.multiEntitySwitcherSlice);
  const { toggle } = useSelector((state) => state?.internalTransactions);

  const isInternalAccountFilterLocked =
    props?.flow !== "labelsSearch" &&
    ((props?.typepop === "ownerDetailTxnHistoryPopUp" &&
      props?.txnHistorytype === "ownerDetailTxnHistory" &&
      props?.balanceType === "credit") ||
      props?.typepop === "RejectInternalAcc" ||
      props?.txnHistorytype === "internalCreateTxn" ||
      loading ||
      (props?.typepop === "txnHistorypopup" && selectedBeneAccId) ||
      props?.txnHistorytype === "internalTxnHistory" ||
      !(
        (props?.label === "categoryName" &&
          props?.typepop === "transactionHistorypopup") ||
        ((props?.typepop !== "transactionHistorypopup" || props?.OwnerDetail) &&
          props?.typepop !== "RejectAllTransactionPopup") ||
        props?.typepop === "BeneAccRejectTxn"
      ));

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleStatus1 = (status) => {
    handleClose();

    let statusToSend;

    switch (status) {
      case "distribution complete":
        statusToSend = "distribution_complete";
        break;
      case "distribution created":
        statusToSend = "created";
        break;
      case "distribution initiated":
        statusToSend = "distribution_initiated";
        break;
      case "distribution approved":
        statusToSend = "approved";
        break;
      case "distribution pending":
        statusToSend = "distribution_pending";
        break;
      case "awaiting funds":
        statusToSend = "awaiting_funds";
        break;
      case "distribution reversal":
        statusToSend = "reversal";
        break;
      case "distribution denied":
        statusToSend = "denied";
        break;
      case "distribution rejected":
        statusToSend = "rejected";
        break;
      case "distribution failed":
        statusToSend = "failed";
        break;
      case "distribution abandoned":
        statusToSend = "abandoned";
        break;
      default:
        statusToSend = status;
        break;
    }

    getAccStatus(statusToSend, "distribution");
    setCurrentPage(GlobalConfiguration.lengthCheckOne);
  };

  const getDisplayDistributionStatus = (status = "") => {
    switch (status) {
      case "distribution_complete":
        return "distribution complete";
      case "created":
        return "distribution created";
      case "distribution_initiated":
        return "distribution initiated";
      case "approved":
        return "distribution approved";
      case "distribution_pending":
        return "distribution pending";
      case "awaiting_funds":
        return "awaiting funds";
      case "reversal":
        return "distribution reversal";
      case "denied":
        return "distribution denied";
      case "rejected":
        return "distribution rejected";
      case "failed":
        return "distribution failed";
      case "abandoned":
        return "distribution abandoned";
      default:
        return status || "";
    }
  };

  const handleStatus = (status) => {
    handleClose1();
    if (status === "require approval") {
      setIsPaymentMethod("");
      setStartDateFilter("");
      setEndDateFilter("");
      handleSubmit("paymentmethod", "");
      handleSubmit("date", "");
    }
    getAccStatus(status, "status");
    setCurrentPage(GlobalConfiguration.lengthCheckOne);
  };

  const handleClose1 = () => {
    // setSelectedOption(false);
    SetDashBoardStatus("all");
    setIsOpen(false);
  };

  const fetchData = async () => {
    setLoadingData(true);

    let response;
    let data = [];

    try {
      switch (active) {
        // case "Category":
        //   response = await dispatch(
        //     getAllCategories({ search_string: searchUserTextDebounce }),
        //   );
        //   data =
        //     response?.payload?.categories?.map((itm) => ({
        //       id: itm.name,
        //       Category: itm.name,
        //       Description: itm?.description || "Not given",
        //     })) || [];
        //   break;

        case "Labels":
          data =
            labels
              ?.filter((itm) => itm.includes(searchUserTextDebounce))
              ?.map((val) => ({ id: val, Label: val })) || [];
          break;

        case "Internal account":
          response = await dispatch(
            getAllInternalAccounts({
              search_string: searchUserTextDebounce,
              page_no: 1,
              page_size: 5,
            }),
          );
          if (response?.payload?.status) {
            data =
              response.payload.internal_accounts?.map((itm) => ({
                id: itm.id,
                Name: itm.name,
                Account_number: itm.bank_acc_no,
                display: itm.name,
                IFSC_code: itm.ifsc_code,
                Contact_number: itm.contact_no,
                Email_ID: itm.email_id,
              })) || [];
          }
          break;

        case "Owner account":
          response = await dispatch(
            ownerAccountsViewAll({
              search_string: searchUserTextDebounce,
              page_no: 1,
              page_size: 5,
            }),
          );
          if (response?.payload?.status) {
            data =
              response.payload.owner_accounts?.map((itm) => ({
                id: itm.id,
                Account_number: itm.bank_acc_no,
                display: itm.bank_acc_no,
                Name: itm.name,
                IFSC_code: itm.ifsc_code,
                Email_ID: itm.email_id,
              })) || [];
          }
          break;
        case "Search":
          setLoadingData(false);
          break;
        default:
          data = [];
          setLoadingData(false);
          break;
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      data = [];
    } finally {
      // 🔹 Spread to force new reference, ensures React detects change
      setInputData([...data]);
      setLoadingData(false);
    }
  };

  const selectableTransactions = accumulatedData
    ?.filter((item) => item?.approval_status !== "archived")
    ?.map((item) => ({ ...item, id: item?.txn_id }));

  const totalRecordCount = Number(mainData?.total_count || 0);

  const effectiveSelectCap =
    totalRecordCount > 0 && totalRecordCount <= Number(selectedValue)
      ? totalRecordCount
      : Number(selectedValue);

  const isAllSelected =
    LabelAccounts?.length === effectiveSelectCap && effectiveSelectCap > 0;

  const handleSelectAll = () => {
    handleMultiSelectAll(
      LabelAccounts,
      setLabelAccounts,
      selectedValue,
      selectableTransactions,
    );
  };

  const handleLabelTransactionSelect = (transaction) => {
    handleSingleSelect(LabelAccounts, setLabelAccounts, selectedValue, {
      ...transaction,
      id: transaction?.txn_id,
    });
  };

  const handleSelect = (value) => {
    if (selectedValue === value) return;
    handleSubmit("pagesize", value);
    if (
      isLabelClicked &&
      value === PaginationConfiguration.paginationSmall &&
      LabelAccounts?.length > PaginationConfiguration.paginationSmall
    ) {
      handleChange(LabelAccounts, setLabelAccounts, value, LabelAccounts);
    }
    setSelectedValue(value);
    setPageSize(value);
    setCurrentPage(GlobalConfiguration.lengthCheckOne);
    setAccumulatedData([]);
    toggleDropdown();
  };

  const handleCloseViewModalOwner = (e) => {
    if (e && e.stopPropagation) {
      e.stopPropagation();
    }
    setIsViewModalOpenOwner(false);
  };

  const handleAccountSelectionOwner = (
    accountName,
    accountNumber,
    accountIfsc,
    beneAccountId,
  ) => {
    setTxnPayLoad({
      ...txnPayLoad,
      ownerAccountId: beneAccountId,
      ownerbankAccountNo: accountNumber,
    });
    handleCloseViewModalOwner();
  };

  const handleAction = async () => {
    if (currentStatus === "require approval") {
      try {
        setLoading(true);

        const responseApproval = await dispatch(
          internalTransactionsActionable({
            page_no: currentPage,
            page_item_count: pageSize,
            category: currentCategory,
            owner_account_id: selectedOwnerAccId
              ? selectedOwnerAccId
              : undefined,
          }),
        );

        const newApprovalData = responseApproval?.payload?.transactions || [];
        setMainData(responseApproval?.payload);
        setAccumulatedData(newApprovalData);

        setLoading(false);
      } catch (error) {
        setAccumulatedData([]);
        setMainData([]);
        setLoading(false);
      }
    } else {
      try {
        setLoading(true);
        let queryParams = {
          page_no: currentPage,
          page_item_count: pageSize,
        };

        const addParamsBasedOnSelection = () => {
          if (
            currentStatusDistribution &&
            currentStatusDistribution !== "all"
          ) {
            queryParams.distribution_lifecycle_status =
              currentStatusDistribution;
          }
          if (
            DistributionDashBoard === false &&
            DashBoardStatus !== "all" &&
            DashBoardStatus !== "confidential"
          ) {
            queryParams.lifecycle_status = DashBoardStatus;
          }
          if (DistributionDashBoard === true) {
            if (DashBoardStatus !== "all") {
              queryParams.distribution_lifecycle_status = DashBoardStatus;
            }
          } else {
            if (
              currentStatusDistribution &&
              currentStatusDistribution !== "all"
            ) {
              queryParams.distribution_lifecycle_status =
                currentStatusDistribution;
            }
          }

          if (currentStatus && currentStatus !== "all") {
            queryParams.lifecycle_status = currentStatus;
          }

          if (currentCategory && currentCategory !== "Select category") {
            queryParams.category = currentCategory;
          }
          // queryParams.sort = accountbalancestate || "newest";
          if (
            startDateFilter &&
            endDateFilter &&
            !isNaN(Number(startDateFilter)) &&
            !isNaN(Number(endDateFilter))
          ) {
            if (navStateAppliedRef.current) {
              queryParams.start_date = startDateFilter;
              queryParams.end_date = endDateFilter;
            } else {
              queryParams.start_date = startDateFilter + 86400;
              queryParams.end_date = endDateFilter + 86400;
            }
          }
          if (isPaymentMethod) {
            queryParams.payment_method = isPaymentMethod;
          }
          if (isConfidentialMethod) {
            queryParams.confidential_transaction = isConfidentialMethod;
          }
          if (labelsFilter?.length && labelsFilter !== "Select labels") {
            queryParams.labels = labelsFilter;
          }
          if (txnAmount !== "") {
            queryParams.amount = txnAmount;
          }
          if (txnAddDetails !== "") {
            queryParams.additional_data = txnAddDetails;
          }
          if (txnAmountFilter !== "") {
            queryParams.amount = txnAmountFilter;
          }
          if (amountRangeFilter?.min !== "") {
            queryParams.min_amount = amountRangeFilter.min;
          }
          if (amountRangeFilter?.max !== "") {
            queryParams.max_amount = amountRangeFilter.max;
          }

          if (selectedOwnerAccId !== "") {
            queryParams.owner_account_id = selectedOwnerAccId;
          }
          if (selectedBeneAccId !== "") {
            queryParams.internal_account_id = selectedBeneAccId;
          }

          const txnIds = [
            ...(txnIdSearch?.trim() ? [txnIdSearch.trim()] : []),
            ...(txnIdsFromNotification || []),
          ];

          if (txnIds?.length) {
            queryParams.txn_id = txnIds;
          }
          if (bankIdentifierSearch?.trim()) {
            queryParams.bank_identifier = bankIdentifierSearch.trim();
          }
        };

        addParamsBasedOnSelection();
        let response;
        if (fromNotification) {
          response = await dispatch(
            internalTransactionsViewAllWithBody({
              ...queryParams,
            }),
          );
        } else {
          response = await dispatch(internalTransactionsViewAll(queryParams));
        }

        const newData = response?.payload?.transactions || [];
        setAccumulatedData(newData);

        setMainData(response?.payload);

        setLoading(false);
        setTotalBalanceAmount(
          Number(
            response?.payload?.total_amount ||
              GlobalConfiguration.lengthCheckZero,
          ),
        );

        if (
          (props?.typepop === "RejectAllTransactionPopup" ||
            props?.typepop === "RejectInternalAcc") &&
          props?.flow !== "labelsSearch"
        ) {
          props?.setShowLoader(false);
        }
      } catch (error) {
        setAccumulatedData([]);
        setMainData([]);
        setLoading(false);
      }
    }
  };

  const { showRestrictedAction } = useRestrictedAction();

  const actionRestricted = () => {
    showRestrictedAction();
  };

  const handleClose = () => {
    setIsLabelPopupOpen(false);

    if (!labelActionDispatchedRef.current) return;

    labelActionDispatchedRef.current = false;
    setLabelAccounts([]);
    setisLabelClicked(false);
    setShowSearchBar(false);
    setCurrentPage(GlobalConfiguration.lengthCheckOne);
  };

  const getErrorMessage = (res) => {
    const p =
      res?.payload.response.data.ids?.unsuccessful_ids[0].errors ||
      res?.payload;
    const e = res?.error;
    if (typeof p === "string") return p;
    if (p?.message) return p.message;
    if (p?.errors?.base?.[0]) {
      const base = p.errors.base[0];
      return typeof base === "string"
        ? base
        : base?.errors?.[0] || base?.message || "Something went wrong";
    }
    if (e?.message) return e.message;
    return "Something went wrong";
  };

  const handleAssignLabelsProp = async (labelsToAssign) => {
    setLoading(true);

    const toArray = (value) => (Array.isArray(value) ? value : [value]);
    const recordIds = toArray(LabelAccounts)
      ?.map((item) => item?.id || item)
      ?.filter(Boolean);

    const res = await dispatch(
      internalTransactionsAddLabel({
        record_ids: recordIds,
        labels: labelsToAssign,
      }),
    );

    const isSuccess = internalTransactionsAddLabel.fulfilled.match(res);

    if (isSuccess) {
      labelActionDispatchedRef.current = true;

      setLabels((prev) =>
        Array.from(new Set([...(prev || []), ...(labelsToAssign || [])])),
      );

      toast.dismiss();
      CommonToast({
        text: "Labels assigned successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        buttonNeeded: false,
      });

      await handleAction();
    } else if (internalTransactionsAddLabel.rejected.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
    }

    setLoading(false);
    return isSuccess;
  };

  const handleUnassignLabelsProp = async (labelsToUnassign) => {
    setLoading(true);

    const toArray = (value) => (Array.isArray(value) ? value : [value]);
    const recordIds = toArray(LabelAccounts)
      ?.map((item) => item?.id || item)
      ?.filter(Boolean);

    const res = await dispatch(
      internalTransactionsRemoveLabel({
        record_ids: recordIds,
        labels: labelsToUnassign,
      }),
    );

    const isSuccess = internalTransactionsRemoveLabel.fulfilled.match(res);

    if (isSuccess) {
      // Set BEFORE the refetch so closing the popup mid-fetch still exits
      labelActionDispatchedRef.current = true;

      toast.dismiss();
      CommonToast({
        text: "Labels unassigned successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        buttonNeeded: false,
      });

      await handleAction();
    } else if (internalTransactionsRemoveLabel.rejected.match(res)) {
      setTimeout(() => {
        toast.dismiss();
        CommonToast({
          text: getErrorMessage(res),
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      }, IntervalConfiguration.intervalExtraLarge);
    }

    setLoading(false);
    return isSuccess;
  };

  const handleFilterDateRange = (date) => {
    if (!date || !date[0] || !date[1]) {
      setStartDateFilter("");
      setEndDateFilter("");
      return;
    }
    const [start, end] = date;
    setStartDateFilter(convertDate(start));
    setEndDateFilter(convertDate(end));
  };

  const handlePaymentMethod = (selectedSettlement) => {
    setIsPaymentMethod(selectedSettlement);
  };

  const handleConfidentialMethod = (selectedConfidential) => {
    setIsConfidentialMethod(selectedConfidential);
  };

  const handlePagination = (page) => {
    handleSubmit("pageno", page);
    setCurrentPage(page);
  };

  const getAccStatus = (item, ele) => {
    if (ele === "distribution") {
      setCurrentStatusDistribution(item);
      handleSubmit("distribution", item);
    } else if (ele === "status") {
      handleSubmit("lifecycle", item);
      setCurrentStatus(item);
    }
  };

  const handleToggle = (newToggleValue) => {
    if (toggle !== newToggleValue) {
      const scrollTarget = scrollContainerRef.current || window;
      scrollTarget.scrollTo({ top: 0, behavior: "smooth" });

      if (!showSearchBar && !isSidebarOpen) {
        dispatch(setToggle(newToggleValue));
      }
    }
  };

  const handleSubmit = (key, value) => {
    if (
      props?.txnHistorytype !== "internalCreateTxn" &&
      props?.txnHistorytype !== "internalTxnHistory" &&
      props?.txnHistorytype !== "ownerDetailTxnHistory" &&
      props?.typepop !== "RejectAllTransactionPopup" &&
      props?.typepop !== "RejectInternalAcc"
    ) {
      handleSearchParams(key, value);
    }
  };

  const views = {
    isInternalAccount:
      props?.typepop === "internalAccTxnHistoryPopUp" &&
      props?.txnHistorytype === "internalTxnHistory",

    isOwnerDetail:
      props?.typepop === "ownerDetailTxnHistoryPopUp" &&
      !!props?.OwnerDetail &&
      props?.txnHistorytype === "ownerDetailTxnHistory",

    isTransactionHistory: props?.typepop === "txnHistoryPopUp",
  };

  const isOwnerAccDetailCreditView =
    views?.isOwnerDetail && props?.balanceType === "credit";

  const isOwnerAccDetailDebitView =
    props?.balanceType === "debit" && views?.isOwnerDetail;

  const updateIsFilterApplied = () => {
    setIsFilterApplied(
      !!currentCategory ||
        !!(startDateFilter && endDateFilter) ||
        !!isPaymentMethod ||
        (!(
          isOwnerAccDetailCreditView ||
          props?.typepop === "internalAccTxnHistoryPopUp"
        ) &&
          !!selectedBeneAccId) ||
        (!isOwnerAccDetailDebitView && !!selectedOwnerAccId) ||
        !!txnIdSearch ||
        !!amountRangeFilter?.min ||
        !!amountRangeFilter?.max ||
        !!txnAmountFilter ||
        !!isConfidentialMethod ||
        !!LabelSearchText?.length,
    );
  };

  // Keep currentStatusDistribution in sync if navigation state changes
  useEffect(() => {
    if (distribution_lifecycle_status) {
      setCurrentStatusDistribution(distribution_lifecycle_status);
    }
  }, [distribution_lifecycle_status]);

  useEffect(() => {
    if (active?.length) {
      fetchData();
    }
  }, [active]);

  // useEffect(() => {
  //   const urlSort = searchParam.get("sort") || "";
  //   setaccountbalancestate(urlSort);
  // }, [searchParam]);

  useEffect(() => {
    if (props?.OwnerDetail && props.balanceType === "credit") {
      setSelectedBeneAccId(props?.BeneAccId ?? "");
      setSelectedOwnerAccId("");
    } else if (props?.OwnerDetail && props.balanceType === "debit") {
      setSelectedOwnerAccId(props?.owner_account_id ?? "");
      setSelectedBeneAccId("");
    }
  }, [props.balanceType, props?.OwnerDetail]);

  useEffect(() => {
    if (isLabelClicked) {
      dispatch(disableSwitcher());
    } else {
      dispatch(enableSwitcher());
    }
  }, [isLabelClicked]);

  useEffect(() => {
    dispatch(enableSwitcher());
    return () => {
      dispatch(resetToggle());
      dispatch(disableSwitcher());
    };
  }, []);

  useEffect(() => {
    handleAction();
    if (location.state?.DistributionDashBoard && !navStateAppliedRef.current) {
      setCurrentStatus("all");
      setCurrentStatusDistribution(
        location.state.distribution_lifecycle_status || "all",
      );
      setStartDateFilter(location.state.startDateLocationState || "");
      setEndDateFilter(location.state.endDateLocationState || "");

      navStateAppliedRef.current = true;
      return;
    }

    let availableLabels = sessionStorage?.getItem("internalTxnLabels");
    const parsedLabels = JSON?.parse(availableLabels);
    setLabels(parsedLabels);
  }, [
    markerData,
    currentPage,
    currentStatus,
    currentStatusDistribution,
    startDateFilter,
    endDateFilter,
    pageSize,
    isPaymentMethod,
    txnAmount,
    txnAddDetails,
    txnAmountFilter,
    amountRangeFilter,
    selectedBeneAccId,
    txnIdSearch,
    bankIdentifierSearch,
    // accountbalancestate,
    selectedOwnerAccId,
    toggle,
    isConfidentialMethod,
    LabelSearchText,
    labelsFilter,
  ]);

  useEffect(() => {
    updateIsFilterApplied();
  }, [
    currentCategory,
    startDateFilter,
    endDateFilter,
    txnAmountFilter,
    amountRangeFilter,
    isPaymentMethod,
    selectedBeneAccId,
    txnIdSearch,
    selectedOwnerAccId,
    isConfidentialMethod,
  ]);

  useEffect(() => {
    if (divRef.current) {
      setDivHeight(divRef.current.offsetHeight);
    }
  }, []);

  return (
    <>
      <div
        id="internalTxnViewAllContainer"
        className={`bg-primary-bg flex relative flex-col overflow-hidden ${
          props?.txnHistorytype === "internalTxnHistory" ||
          props?.txnHistorytype === "internalCreateTxn" ||
          props?.txnHistorytype === "ownerDetailTxnHistory" ||
          props?.typepop === "RejectAllTransactionPopup" ||
          props?.typepop === "RejectInternalAcc"
            ? "h-height-full relative"
            : ""
        }`}
      >
        {isLabelPopupOpen && (
          <div className="fixed left-left-base w-full top-top-base h-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-max-zindex">
            <CommonAssignLabelPopup
              headerTitle="Assign/unassign labels:"
              headersubtext="Labels will be used to generate statistics for the associated transactions."
              closehandleFunction={handleClose}
              closeisDisabled={false}
              labels={labels}
              setLabels={setLabels}
              LabelAccounts={LabelAccounts}
              isLabelPopupOpen={isLabelPopupOpen}
              filteredData={LabelAccounts}
              onClose={handleClose}
              loading={loading}
              setLoading={setLoading}
              handleAssignLabels={handleAssignLabelsProp}
              handleUnassignLabels={handleUnassignLabelsProp}
              type="viewall"
            />
          </div>
        )}

        {/*Owner Account Modal*/}
        {isViewModalOpenOwner && (
          <div className="fixed top-top-base left-left-base w-width-full h-height-full bg-Primary-black bg-opacity-dark-opacity z-z-index-modal">
            <OwnerAccountPopUp
              setIsSidebarOpen={setIsSidebarOpen}
              onClosed={handleCloseViewModalOwner}
              onAccountSelect={handleAccountSelectionOwner}
              setTxnPayLoad={setTxnPayLoad}
              setOpenOwner={setIsViewModalOpenOwner}
              txnPayLoad={txnPayLoad}
              accountNumber={accountNumber}
              IFSC={IFSC}
              flow={"txnViewAll"}
              handlePopupClose={() => {
                setIsViewModalOpenOwner(false);
              }}
            />
          </div>
        )}

        <div
          className={`bg-primary-bg flex flex-col relative ${
            props?.txnHistorytype === "internalTxnHistory" ||
            props?.txnHistorytype === "internalCreateTxn" ||
            props?.txnHistorytype === "ownerDetailTxnHistory" ||
            props?.internalAccount ||
            props?.typepop === "RejectAllTransactionPopup" ||
            props?.typepop === "RejectInternalAcc"
              ? "h-height-full"
              : "h-screen"
          }`}
          id="benetxnmain"
          style={{
            overflow: isSidebarOpen && "hidden",
          }}
        >
          {/*Web Nav Bar*/}
          <div className="hidden Qsmd:flex flex-col">
            <div
              className="relative bg-primary-nav z-z-index-overlay"
              style={{
                height:
                  props?.txnHistorytype === "internalTxnHistory" ||
                  props?.txnHistorytype === "internalCreateTxn" ||
                  (props?.txnHistorytype === "ownerDetailTxnHistory" &&
                    props?.internalAccount) ||
                  props?.typepop === "RejectAllTransactionPopup" ||
                  props?.typepop === "RejectInternalAcc" ||
                  props?.txnHistorytype === "ownerDetailTxnHistory"
                    ? ""
                    : "var(--navbar-breadcrumb-height)",
              }}
            ></div>
          </div>
          <div className="z-z-index-overlay">
            <TopNavComponent
              topNavHeader={totalBalanceAmount}
              topNavSubText={"Total amount"}
              topNavCtaBtn1Needed={isLabelClicked}
              topNavCtaBtn1Props={
                isLabelClicked
                  ? {
                      btnText:
                        Array.isArray(LabelAccounts) &&
                        LabelAccounts.length >
                          GlobalConfiguration.lengthCheckZero
                          ? "Clear"
                          : "Cancel",
                      btnType: "button",
                      enabledBgColor: "var(--primary-nav-act)",
                      handleFunction: () => {
                        // setLabelAccounts([]);
                        // setisLabelClicked(false);
                        if (
                          LabelAccounts?.length >
                          GlobalConfiguration.lengthCheckZero
                        ) {
                          setLabelAccounts([]);
                        } else {
                          setisLabelClicked(false);
                          // navigate(-1);
                        }
                      },
                      hoverOption: "white",
                      enabledTextColor: "var(--text-primary)",
                      isDisabled: false,
                    }
                  : undefined
              }
              topNavCtaBtn2Needed={isLabelClicked}
              topNavCtaBtn2Props={
                isLabelClicked
                  ? {
                      btnText: "Assign Labels",
                      btnType: "button",
                      enabledBgColor: LabelAccounts?.length
                        ? "var(--text-primary)"
                        : "var(--text-disabled)",
                      handleFunction: (e) => {
                        e.stopPropagation();
                        if (!LabelAccounts.length) return;
                        labelActionDispatchedRef.current = false;
                        setIsLabelPopupOpen(true);
                      },
                      enabledTextColor: LabelAccounts?.length
                        ? "var(--primary-bg)"
                        : "var(--text-primary)",
                      isDisabled: !LabelAccounts?.length,
                      inActiveVariantNeeded: true,
                      hoverOption: LabelAccounts?.length ? "black" : "white",
                    }
                  : undefined
              }
              isSelectionView={isLabelClicked}
              selectionText={`Transactions selected - ${LabelAccounts?.length || GlobalConfiguration.lengthCheckZero}`}
              BottomSubText={
                isLabelClicked
                  ? "Select transactions to apply labels. These labels will be used to generate statistics for the associated transactions."
                  : ""
              }
              BottomSubTextVaraint="primary"
              selectionBtnProps={
                isLabelClicked
                  ? {
                      btnText: `Select up to ${Number(selectedValue)}`,
                      enabledBgColor: `${
                        isAllSelected
                          ? "var(--positive-bg)"
                          : "var(--primary-nav-act)"
                      }`,
                      isDisabled:
                        loading ||
                        selectableTransactions?.length ===
                          GlobalConfiguration.lengthCheckZero
                          ? true
                          : false,
                      handleFunction: (e) => {
                        e.stopPropagation();
                        if (selectableTransactions?.length) {
                          handleSelectAll();
                        }
                      },
                      iconToBeAlign: "left",
                      enabledTextColor: "var(--text-primary)",
                      icon: isAllSelected
                        ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                        : ICONS?.SELECT_ALL_WITH_WHITE_OUTLINE_CIRCLE,
                      fullWidthRequired: false,
                      hoverOption: `${LabelAccounts?.length ? "black" : "white"}`,
                    }
                  : undefined
              }
              isToggleNeeded={true}
              toggleProps={{
                state: toggle,
                title: toggle ? "Grid View" : "List View",
                isDisabled: false,
                handleClick: () => {
                  handleToggle(!toggle);
                },
              }}
              ispagination={
                accumulatedData?.length <= GlobalConfiguration.lengthCheckZero
                  ? false
                  : true
              }
              filteredSearchProps={{
                setShowInnerSearchBar: setShowInnerSearchBar,
                showSearchBar: showSearchBar,
                isSearchDisabled: loading,
                onSearchInput: (val) => setSearchUserTextDebounce(val),
                searchText: searchUserTextDebounce,
                searchPlaceholder: "Search internal transaction",
                filterPlaceholder: "transaction details",
                filterItems: [
                  {
                    name: "Search",
                    isMulti: false,
                    value: txnAddDetails,
                    setValue: (val) => {
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      handleSubmit("search", val);
                      setTxnAddDetails(val);
                    },
                    isDropdown: false,
                    isDisabled: loading,
                  },
                  {
                    name: "Internal account",
                    short_name: "Int. Acc",
                    isMulti: false,
                    value: selectedBeneAccId,
                    displayValue: props?.internal_acc_name
                      ? props?.internal_acc_name
                      : (props.typepop === "transactionHistorypopup" ||
                            props.typepop === "txnHistorypopup") &&
                          props.label === "categoryName"
                        ? accountNameValue
                            .toLowerCase()
                            .split(" ")
                            .map(
                              (word) =>
                                word.charAt(0).toUpperCase() + word.slice(1),
                            )
                            .join(" ")
                        : props?.txnHistorytype === "internalTxnHistory" ||
                            props?.txnHistorytype === "internalCreateTxn"
                          ? standardAccountNumberFormat(
                              props?.internal_account_bank_acc_no,
                              true,
                            )
                          : props?.typepop === "transactionHistorypopup" ||
                              props.typepop === "txnHistorypopup" ||
                              accountName
                                ?.toLowerCase()
                                .split(" ")
                                .map(
                                  (word) =>
                                    word.charAt(0).toUpperCase() +
                                    word.slice(1),
                                )
                                .join(" ")
                            ? accountName
                                ?.toLowerCase()
                                .split(" ")
                                .map(
                                  (word) =>
                                    word.charAt(0).toUpperCase() +
                                    word.slice(1),
                                )
                                .join(" ")
                            : accountNameValue
                                ?.toLowerCase()
                                .split(" ")
                                .map(
                                  (word) =>
                                    word.charAt(0).toUpperCase() +
                                    word.slice(1),
                                )
                                .join(" "),
                    setValue: (val) => {
                      if (isInternalAccountFilterLocked) return;
                      handleSubmit("beneAcc", val);
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      setSelectedBeneAccId(val);
                    },

                    setDisplayValue: (val) => {
                      setAccountName(val);
                      setAccountNameValue(val);
                    },
                    isDropdown: true,
                    valueType: "string",
                    isDisabled: isInternalAccountFilterLocked,
                  },
                  {
                    name: "Owner account",
                    short_name: "Own. Acc",
                    isMulti: false,
                    value: selectedOwnerAccId,
                    displayValue: standardAccountNumberFormat(
                      accountNumber,
                      true,
                    ),
                    setValue: (val) => {
                      handleSubmit("sourceAcc", val);
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      setSelectedOwnerAccId(val);
                    },
                    setDisplayValue: setAccountNumber,
                    valueType: "string",
                    isDropdown: true,
                    isDisabled: loading
                      ? true
                      : props?.type === "RejectInternalTxn" &&
                          props?.typepop === "RejectInternalAcc"
                        ? false
                        : isOwnerAccDetailDebitView
                          ? true
                          : views?.isOwnerDetail
                            ? false
                            : views?.isInternalAccount
                              ? false
                              : props?.txnHistorytype ===
                                    "internalTxnHistory" ||
                                  props?.txnHistorytype === "internalCreateTxn"
                                ? true
                                : props?.OwnerDetail
                                  ? true
                                  : false,
                  },
                  {
                    name: "Transaction ID",
                    short_name: "Transaction ID",
                    isMulti: false,
                    value: txnIdSearch,
                    setValue: (val) => {
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      handleSubmit("txn_id", val);
                      setTxnIdSearch(val);
                    },
                    isDropdown: false,
                    isDisabled: loading,
                  },
                  {
                    name: "Bank identifier",
                    short_name: "Bank ID",
                    isMulti: false,
                    value: bankIdentifierSearch,
                    setValue: (val) => {
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      handleSubmit("bank_id", val);
                      setBankIdentifierSearch(val);
                    },
                    isDropdown: false,
                    isDisabled: loading,
                  },
                  {
                    name: "Labels",
                    short_name: "Lab",
                    isMulti: true,
                    value: labelsFilter,
                    setValue: (val) => {
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      handleSubmit("label", val);
                      setFilterLabels(val);
                    },
                    isDropdown: true,
                    valueType: "string",
                    isDisabled: loading || props?.flow === "labelsSearch",
                  },
                ],
                filters: [
                  {
                    name: "Approval status",
                    filterType: "dropdown",
                    variant: "single",
                    size: "small",
                    value: currentStatus === undefined ? "" : currentStatus,
                    dropdownPlaceHolder: "Select status",
                    isDisabled:
                      props?.flow === "labelsSearch"
                        ? false
                        : props?.typepop === "RejectInternalAcc"
                          ? true
                          : currentStatusDistribution?.length >
                              GlobalConfiguration.lengthCheckZero
                            ? true
                            : false,
                    options:
                      (services?.includes("CInternalTxn") &&
                        !services?.includes("AInternalTxn")) ||
                      fromNotification
                        ? ["approved", "pending", "rejected", "abandoned"]
                        : [
                            "approved",
                            "require approval",
                            "pending",
                            "rejected",
                            "abandoned",
                          ],
                    statusPop: true,
                    handleChange: handleStatus,
                  },

                  {
                    name: "Distribution status",
                    filterType: "dropdown",
                    variant: "single",
                    size: "small",
                    value: getDisplayDistributionStatus(
                      currentStatusDistribution,
                    ),
                    dropdownPlaceHolder: "Select status",
                    isDisabled:
                      currentStatus?.length >
                      GlobalConfiguration.lengthCheckZero
                        ? true
                        : false,
                    options: [
                      "distribution complete",
                      "distribution created",
                      "distribution approved",
                      "awaiting funds",
                      "distribution initiated",
                      "distribution pending",
                      "distribution rejected",
                      "distribution failed",
                      "distribution reversal",
                      "distribution denied",

                      "distribution abandoned",
                    ],
                    statusPop: true,
                    handleChange: handleStatus1,
                  },
                  {
                    name: "Payment method",
                    filterType: "dropdown",
                    variant: "single",
                    isSearch: false,
                    options: ["NEFT", "RTGS"],
                    searchPlaceholder: "Search",
                    dropdownPlaceHolder: "Select type",
                    value: isPaymentMethod,
                    isDisabled:
                      (props?.txnHistorytype === "internalCreateTxn" &&
                        duplicateFilters?.payment_method) ||
                      currentStatus === "require approval",
                    handleChange: (val) => {
                      handleSubmit("paymentmethod", val);
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      handlePaymentMethod(val);
                    },
                    dropdownType: "PaymentMethod",
                  },
                  services.includes("VConfidentialTxn") && {
                    name: "Show/hide confidential transactions",
                    filterType: "dropdown",
                    variant: "single",
                    isSearch: false,
                    options: ["Show only confidential", "Hide confidential"],
                    searchPlaceholder: "Search",
                    isDisabled:
                      (props?.txnHistorytype === "internalCreateTxn" &&
                        duplicateFilters?.confidential_transaction ===
                          "Show only confidential") ||
                      (DashBoardisConfidentialFilter ===
                        "Show only confidential" &&
                        DashBoardStatus === "confidential") ||
                      props?.internal_account_confidential === "Y",
                    dropdownPlaceHolder: "Default (all transactions)",
                    value: isConfidentialMethod,
                    handleChange: (val) => {
                      handleSubmit("confidential", val);
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      handleConfidentialMethod(val);
                    },
                  },
                  {
                    name: "Amount range",
                    filterType: "amountRange",
                    variant: "single",
                    size: "small",
                    value: isAmtFilterApplied,
                    rangeValue: amountRangeFilter,
                    setShowAmtFilterDiv: setShowAmtFilterDiv,
                    setIsAmtFilterApplied: setIsAmtFilterApplied,
                    handleChange: (val) => {
                      if (typeof val === "function") {
                        setAmountRangeFilter((prev) => val(prev));
                        return;
                      }

                      if (val && typeof val === "object") {
                        const nextMin = val?.min ?? "";
                        const nextMax = val?.max ?? "";
                        setAmountRangeFilter({
                          min: nextMin,
                          max: nextMax,
                        });
                        setCurrentPage(GlobalConfiguration.lengthCheckOne);
                        handleSubmit("min_amount", nextMin);
                        handleSubmit("max_amount", nextMax);
                        return;
                      }

                      setAmountRangeFilter({ min: "", max: "" });
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      handleSubmit("min_amount", "");
                      handleSubmit("max_amount", "");
                    },
                    isDisabled:
                      props?.txnHistorytype === "internalCreateTxn" &&
                      duplicateFilters?.amount,
                  },
                  {
                    name: "Date range",
                    filterType: "calender",
                    variant: "range",
                    size: "small",
                    value: startDateFilter && endDateFilter,
                    isDisabled: currentStatus === "require approval",
                    startDate: startDateFilter
                      ? new Date(startDateFilter * 1000)
                      : startDateFilter,
                    endDate: endDateFilter
                      ? new Date(endDateFilter * 1000)
                      : endDateFilter,
                    handleChange: (date) => {
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      handleSubmit("date", date);
                      handleFilterDateRange(date);
                    },
                  },
                ],

                isSearchClearAllDisabled:
                 props?.typepop === "RejectInternalAcc"
  ? !(
      (
        selectedBeneAccId !== "" &&
        (
          txnAddDetails !== "" ||
          txnIdSearch !== "" ||
          bankIdentifierSearch !== "" ||
          txnAmountFilter !== "" ||
          searchUserTextDebounce !== "" ||
          selectedOwnerAccId !== "" ||
          labelsFilter.length >
            GlobalConfiguration.lengthCheckZero
        )
      ) ||
      (
        selectedBeneAccId === "" &&
        (
          txnAddDetails !== "" ||
          txnIdSearch !== "" ||
          bankIdentifierSearch !== "" ||
          txnAmountFilter !== "" ||
          searchUserTextDebounce !== "" ||
          selectedOwnerAccId !== "" ||
          labelsFilter.length >
            GlobalConfiguration.lengthCheckZero
        )
      )
    )
  
                    : props?.flow === "labelsSearch"
                      ? !(
                          txnAddDetails !== "" ||
                          txnIdSearch !== "" ||
                          bankIdentifierSearch !== "" ||
                          txnAmountFilter !== "" ||
                          searchUserTextDebounce !== "" ||
                          selectedOwnerAccId !== "" ||
                          selectedBeneAccId !== "" ||
                          labelsFilter.length >
                            GlobalConfiguration.lengthCheckZero
                        )
                      : !(
                          props?.txnHistorytype === "internalCreateTxn" &&
                          duplicateFilters?.amount &&
                          duplicateFilters?.owner_account_id &&
                          duplicateFilters?.internal_account_id &&
                          duplicateFilters?.payment_method &&
                          (txnAddDetails !== "" ||
                            txnIdSearch !== "" ||
                            bankIdentifierSearch !== "" ||
                            searchUserTextDebounce !== "" ||
                            labelsFilter.length >
                              GlobalConfiguration.lengthCheckZero)
                        ) ||
                        (props?.txnHistorytype === "internalTxnHistory" &&
                          (props?.typepop === "Transaction history" ||
                            props?.typepop === "Confidential transaction") &&
                          selectedOwnerAccId !== "" &&
                          selectedBeneAccId !== "" &&
                          !(
                            txnAddDetails !== "" ||
                            txnIdSearch !== "" ||
                            bankIdentifierSearch !== "" ||
                            txnAmountFilter !== "" ||
                            labelsFilter.length >
                              GlobalConfiguration.lengthCheckZero
                          )) ||
                        (props?.typepop === "RejectInternalAcc" &&
                          props?.type === "RejectInternalTxn" &&
                          !(
                            txnAddDetails !== "" ||
                            txnIdSearch !== "" ||
                            selectedOwnerAccId !== "" ||
                            bankIdentifierSearch !== "" ||
                            txnAmountFilter !== "" ||
                            labelsFilter.length >
                              GlobalConfiguration.lengthCheckZero
                          )) ||
                        (props?.txnHistorytype === "ownerDetailTxnHistory" &&
                          props?.balanceType === "credit" &&
                          props?.typepop === "ownerDetailTxnHistoryPopUp" &&
                          selectedBeneAccId !== "" &&
                          !(
                            txnAddDetails !== "" ||
                            txnIdSearch !== "" ||
                            selectedOwnerAccId !== "" ||
                            bankIdentifierSearch !== "" ||
                            labelsFilter.length >
                              GlobalConfiguration.lengthCheckZero
                          )) ||
                        (props?.txnHistorytype === "ownerDetailTxnHistory" &&
                          props?.balanceType === "debit" &&
                          props?.typepop === "ownerDetailTxnHistoryPopUp" &&
                          selectedOwnerAccId !== "" &&
                          !(
                            txnAddDetails !== "" ||
                            txnIdSearch !== "" ||
                            selectedBeneAccId !== "" ||
                            bankIdentifierSearch !== "" ||
                            labelsFilter.length >
                              GlobalConfiguration.lengthCheckZero
                          )) ||
                        (props?.typepop === "internalAccTxnHistoryPopUp" &&
                          props?.txnHistorytype === "internalTxnHistory" &&
                          selectedBeneAccId !== "" &&
                          !(
                            txnAddDetails !== "" ||
                            txnIdSearch !== "" ||
                            bankIdentifierSearch !== "" ||
                            selectedOwnerAccId !== "" ||
                            labelsFilter.length >
                              GlobalConfiguration.lengthCheckZero
                          )),

                isFilterClearAllDisabled:
                  props?.flow === "labelsSearch"
                    ? !(
                        isConfidentialMethod ||
                        isPaymentMethod ||
                        (startDateFilter && endDateFilter) ||
                        isAmtFilterApplied ||
                        currentStatus?.length >
                          GlobalConfiguration.lengthCheckZero ||
                        currentStatusDistribution?.length >
                          GlobalConfiguration.lengthCheckZero
                      )
                    : props?.txnHistorytype === "internalCreateTxn" &&
                        duplicateFilters?.payment_method
                      ? !(
                          (props?.txnHistorytype === "internalCreateTxn" &&
                            duplicateFilters?.confidential_transaction !==
                              "Show only confidential" &&
                            isConfidentialMethod) ||
                          (startDateFilter && endDateFilter) ||
                          isAmtFilterApplied ||
                          (props?.typepop !== "RejectInternalAcc" &&
                            currentStatus?.length >
                              GlobalConfiguration.lengthCheckZero) ||
                          currentStatusDistribution?.length >
                            GlobalConfiguration.lengthCheckZero
                        )
                      : (DashBoardisConfidentialFilter ===
                            "Show only confidential" &&
                            DashBoardStatus === "confidential") ||
                          props?.internal_account_confidential === "Y"
                        ? !(
                            isPaymentMethod ||
                            (startDateFilter && endDateFilter) ||
                            isAmtFilterApplied ||
                            (props?.typepop !== "RejectInternalAcc" &&
                              currentStatus?.length >
                                GlobalConfiguration.lengthCheckZero) ||
                            currentStatusDistribution?.length >
                              GlobalConfiguration.lengthCheckZero
                          )
                        : !(
                            isConfidentialMethod ||
                            isPaymentMethod ||
                            isAmtFilterApplied ||
                            (startDateFilter && endDateFilter) ||
                            (props?.typepop !== "RejectInternalAcc" &&
                              currentStatus?.length >
                                GlobalConfiguration.lengthCheckZero) ||
                            currentStatusDistribution?.length >
                              GlobalConfiguration.lengthCheckZero
                          ),
                inputData: inputData,
                active: active,
                setActive: setActive,
                loading: loading,
                loadingData: loadingData,
                setLoading: setLoadingData,
                isShowFilter: true,
                isShowSortBy: false,
                // sortByFilter: [
                //   {
                //     name: "Newest",
                //     default: true,
                //     isDisabled: false,
                //   },
                //   {
                //     name: "Oldest first",
                //     isDisabled: false,
                //   },
                //   {
                //     name: "Amount:Low to high",
                //     isDisabled: false,
                //   },
                //   {
                //     name: "Amount:High to low",
                //     isDisabled: false,
                //   },
                // ],
                // sortHandleChange: (val) => {
                //   const mappedSort = sortMapper[val] || "";

                //   handleSubmit("sort", mappedSort);
                //   setCurrentPage(GlobalConfiguration.lengthCheckOne);
                //   setaccountbalancestate(mappedSort);
                // },
                // sortValue: accountbalancestate,
                isSortDisabled: loading,
                isFilterDisabled: loading,

                // Callback to reset notification state when search/filter parameters are explicitly cleared
                onClearAllAdvice: () => {
                  setFromNotification(false);
                  setTxnIdsFromNotification([]);
                },
              }}
              assignLabelProps={
                !isLabelClicked
                  ? {
                      isDisabled:
                        loading ||
                        props?.txnHistorytype === "internalTxnHistory" ||
                        props?.txnHistorytype === "internalCreateTxn" ||
                        props.typepop === "transactionHistorypopup" ||
                        props.typepop === "txnHistorypopup" ||
                        props?.typepop === "RejectAllTransactionPopup" ||
                        props.typepop === "RejectInternalAcc" ||
                        props.txnHistorytype === "ownerDetailTxnHistory",
                      enabledBgColor: "var(--primary-bg)",
                      handleFunction: () => {
                        if (loading) return;
                        if (
                          props?.txnHistorytype === "internalTxnHistory" ||
                          props?.txnHistorytype === "internalCreateTxn" ||
                          props.typepop === "transactionHistorypopup" ||
                          props.typepop === "txnHistorypopup" ||
                          props?.typepop === "RejectAllTransactionPopup" ||
                          props.typepop === "RejectInternalAcc" ||
                          props.txnHistorytype === "ownerDetailTxnHistory"
                        ) {
                          actionRestricted();
                        } else {
                          if (
                            services?.includes("ALabel") &&
                            services?.includes("RLabel")
                          ) {
                            setisLabelClicked((prev) => {
                              if (prev) setLabelAccounts([]);
                              return !prev;
                            });
                          } else {
                            navigate("/feature_not_assigned", {
                              state: {
                                unavailableService: "ALabel,RLabel",
                              },
                            });
                          }
                        }
                      },
                      hoverOption: "white",

                      disabledBgColor: "var(--primary-bg)",
                      title:
                        "Labels will be used to generate statistics for the associated transactions.",
                    }
                  : undefined
              }
            />
          </div>
          {/*Scroll Container*/}

          {showInnerSearchBar && (
            <div class="absolute bg-PopUp-BackDrop opacity-light-opacity pointer-events-none w-full h-full z-z-index-header"></div>
          )}
          <div
            ref={scrollContainerRef}
            className={`internalScrollDiv flex-1 overflow-y-scroll z-z-index-base relative ${
              accumulatedData?.length === GlobalConfiguration.lengthCheckZero ||
              loading
                ? "pb-bottom-base"
                : isLabelClicked
                  ? "Qsmd:mb-margin-base mb-[var(--topnavbar-min-height)]"
                  : ""
            }`}
            style={{
              pointerEvents: showInnerSearchBar ? "none" : "",
              scrollPaddingTop: "var(--padding-md)",
              scrollPaddingBottom: isLabelClicked
                ? "var(--padding-lg)"
                : "var(--padding-md)",
            }}
          >
            {loading ? (
              <div className="loader-container m-auto flex justify-center items-center h-height-full">
                <Loader />
              </div>
            ) : accumulatedData?.length >
              GlobalConfiguration?.lengthCheckZero ? (
              !toggle ? (
                <div className="flex flex-col w-width-full flex-1 min-h-height-base m-auto">
                  <InternalTransactionGridView
                    loading={loading}
                    data={accumulatedData?.map((item) => ({
                      ...item,
                      id: item?.txn_id,
                    }))}
                    txnId={props?.txnId}
                    filterRef={scrollContainerRef}
                    lastElementRef={lastElementRef}
                    isSidebarOpen={isSidebarOpen}
                    numberOfPages={totalPages}
                    isCardHovered={isCardHovered}
                    setIsCardHovered={setIsCardHovered}
                    isPopoverOpen={isPopoverOpen}
                    currentStatus={currentStatus}
                    isDistributionPopoverOpen={isDistributionPopoverOpen}
                    txnHistorytype={props?.txnHistorytype}
                    onClose={props?.onClose}
                    paginationDivHeight={divHeight}
                    isLabelClicked={isLabelClicked}
                    LabelAccounts={LabelAccounts}
                    handleLabelSelect={handleLabelTransactionSelect}
                    setlableInput={(e) => {}}
                    setOpenTransHistory={props?.setOpenTransHistory}
                    setLoading={props?.setLoading}
                    onCardNavigate={props?.onCardNavigate}
                    flowType={props?.flow}
                  />
                </div>
              ) : (
                <div className="flex flex-col flex-1 min-h-height-base items-center w-width-full m-auto">
                  <InternalTransactionListView
                    loading={loading}
                    filterRef={scrollContainerRef}
                    data={accumulatedData?.map((item) => ({
                      ...item,
                      id: item?.txn_id,
                    }))}
                    txnId={props?.txnId}
                    isSidebarOpen={isSidebarOpen}
                    page={currentPage}
                    isPopoverOpen={isPopoverOpen}
                    currentStatus={currentStatus}
                    isDistributionPopoverOpen={isDistributionPopoverOpen}
                    txnHistorytype={props?.txnHistorytype}
                    onClose={props?.onClose}
                    isLabelClicked={isLabelClicked}
                    LabelAccounts={LabelAccounts}
                    handleLabelSelect={handleLabelTransactionSelect}
                    setlableInput={(e) => {}}
                    paginationDivHeight={divHeight}
                    setOpenTransHistory={props?.setOpenTransHistory}
                    setLoading={props?.setLoading}
                    onCardNavigate={props?.onCardNavigate}
                    flowType={props?.flow}
                  />
                </div>
              )
            ) : (
              <div
                className={`flex flex-col items-center justify-center m-auto h-height-full ${
                  !toggle &&
                  (isSidebarOpen || isPopoverOpen || isDistributionPopoverOpen)
                    ? "bg-Primary-black opacity-light-opacity"
                    : ""
                }`}
              >
                <img
                  src={ICONS?.NO_DATA_FOUND}
                  alt="No transactions found"
                  className="w-graphic-width-md h-graphic-rectangle-height-md"
                />
                <p className="text-font-sm text-text-primary text-center font-sans font-normal my-margin-sm">
                  No data found.
                </p>

                {(isFilterApplied ||
                  txnAmount ||
                  txnAddDetails ||
                  currentStatus ||
                  currentStatusDistribution) && (
                  <PrimaryButton
                    enabledBgColor="var(--primary-nav-act)"
                    btnText="Clear parameters"
                    btnType="button"
                    handleFunction={(e) => {
                      setSearchUserTextDebounce("");

                      if (props?.txnHistorytype !== "internalCreateTxn") {
                        setTxnAmount("");
                        setTxnAmountFilter("");
                        setAmountRangeFilter({ min: "", max: "" });
                        setIsPaymentMethod("");
                      }
                      setIsConfidentialMethod("");
                      if (
                        props?.typepop !== "RejectInternalAcc" &&
                        !fromNotification
                      ) {
                        setCurrentStatus("");
                        setCurrentStatusDistribution("");
                      }

                      if (
                        (props?.typepop === "RejectInternalAcc" &&
                          props?.type === "RejectInternalTxn") ||
                        (props?.typepop === "internalAccTxnHistoryPopUp" &&
                          props?.txnHistorytype === "internalTxnHistory")
                      ) {
                        setSelectedOwnerAccId("");
                      }
                      setBankIdentifierSearch("");
                      if (isOwnerAccDetailCreditView) {
                        setSelectedOwnerAccId("");
                      }
                      if (isOwnerAccDetailDebitView) {
                        setSelectedBeneAccId("");
                      }
                      setTxnAddDetails("");
                      setTxnIdSearch("");
                      setLabelSearchText([]);
                      if (props?.flow !== "labelsSearch") {
                        setFilterLabels([]);
                      }
                      setIsAmtFilterApplied(false);
                      setisLabelClicked(false);
                      setStartDateFilter("");
                      setEndDateFilter("");
                    }}
                    enabledTextColor="var(--text-primary)"
                  />
                )}
              </div>
            )}
          </div>
          {accumulatedData?.length > GlobalConfiguration.lengthCheckZero &&
            !loading && (
              <div
                ref={divRef}
                className={`w-width-full z-z-index-content bg-primary-nav ${
                  props?.txnHistorytype === "internalTxnHistory" ||
                  props?.txnHistorytype === "internalCreateTxn" ||
                  props?.txnHistorytype === "ownerDetailTxnHistory" ||
                  props?.typepop === "RejectAllTransactionPopup"
                    ? "w-width-full Qmd:w-full_popup-width  rounded-none Qmd:rounded-b-border-radius-md Qmd:rounded-t-none"
                    : "w-width-full rounded-none"
                } ${
                  props?.typepop === "RejectAllTransactionPopup" ? "h-auto" : ""
                }  ${(isPopoverOpen || isSidebarOpen || isDistributionPopoverOpen) && "pointer-events-none"}`}
              >
                <div
                  className={`${
                    !accumulatedData.length &&
                    props?.typepop === "RejectAllTransactionPopup"
                      ? "hidden Qmd:block"
                      : `block ${showInnerSearchBar && `pointer-events-none`}`
                  }`}
                >
                  <PaginationComponent
                    handleSelect={handleSelect}
                    selectedValue={selectedValue}
                    data={mainData}
                    pageSize={pageSize}
                    dropdownOptions={dropdownOptions}
                    handlePagination={handlePagination}
                    currentPage={currentPage}
                    typepop={props?.typepop}
                    handleRejectAllTransaction={
                      props?.handleRejectAllTransaction
                    }
                    accountFlow={"Internal"}
                    setIsOpen={setIsOpen}
                    typePopup={props?.typepop === "popup"}
                  />
                </div>
              </div>
            )}
        </div>
      </div>
    </>
  );
};
export default InternalTransactionViewAll;
